import React, { useState, useEffect } from 'react';
import { getSettings } from '../../util/getSettings';
import Counter from '../shared/counter';

const BedsBaths = ({ bedCount, bathCount, onChange }) => {
  const [beds, setBeds] = useState();
  const [baths, setBaths] = useState();
  const labels = getSettings(['century', 'labels'], true);

  const onCountChange = (bedrooms, bathrooms) => {
    onChange(bedrooms, bathrooms);
  };

  useEffect(() => {
    setBeds(bedCount);
    setBaths(bathCount);
  }, [bedCount, bathCount]);

  return (
    <fieldset className="bedsBaths">
      <legend className="filter-title">{labels.bedsAndBathsFilterLabel}</legend>
      <div className="bedsBaths__flex">
        <Counter
          label={labels.bedroomsLabel}
          countValue={beds}
          onCountChange={(count) => {
            setBeds(count);
            onCountChange(count, baths);
          }}
        />
        <Counter
          label={labels.bathroomsLabel}
          countValue={baths}
          onCountChange={(count) => {
            setBaths(count);
            onCountChange(beds, count);
          }}
        />
      </div>
    </fieldset>
  );
};
export default BedsBaths;
